import { OnInit, Component, Input, ViewChild } from "@angular/core";
import { Operator, OPERATORS } from "../../shared/models/operators";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Rule } from "../../shared/models/rule";
import { QueryBuilder } from "../../shared/models/queryBuilder";
import { PageEvent, MatTableDataSource, MatPaginator, MatSort, MatSnackBar } from "@angular/material";
import { CreativeTemplate } from "../../shared/models/creativeTemplate";
import { CreativeTemplateService } from "../../shared/services/creativeTemplate.service";
import { CampaignType } from "../../shared/models/CampaignType";
import { AgeRangeService } from "../../shared/services/ageRange.service";
import { CampaignTypeService } from "../../shared/services/campaignType.service";
import { AgeRange } from "../../shared/models/ageRange";
import { QueryBuilderUpdate } from "../../shared/models/queryBuilderUpdate";
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { FileService } from '../../shared/services/file.service';
import { SpinnerService } from '../../shared/components/spinner/spinner.service';


@Component({
  selector: 'app-matrix-query-builder',
  templateUrl: './matrix-query-builder.component.html'
})

export class MatrixQueryBuilderComponent implements OnInit {

  public fieldNames: string[] = ['ageRange', 'gender', 'months', 'campaignType'];
  public operators: Operator[] = OPERATORS;
  public showAddRule = false;
  public showEditRule = false;
  public rules: Array<Rule> = [];
  private condition = "and";
  public ruleErrors = "";
  public editRuleErrors = "";
  public showUpdateCard = false;
  public showValue = true;
  public showGender = false;
  public showMonths = false;
  public showAgeRange = false;
  public showCampaignType = false;
  public ageRangeSelected: string[];
  public campaignTypeSelected: string[];
  public genderSelected = "";

  ruleForm: FormGroup;
  editRuleForm: FormGroup;
  submitted = false;
  public currentRule = new Rule();
  public editRuleSubmitted = false;
  private _id;
  public ageRangeList: AgeRange[];  
  public genderList = ['F', 'M'];
  public campaignTypeList: CampaignType[];
  public selectedValues: string[] = [];
  // data source fields
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource1 = new MatTableDataSource<CreativeTemplate>();
  displayedColumns: string[] = ['brandName', 'templateId', 'campaignTypeName', 'months', 'ageRangeName', 'gender', 'frontImage', 'frontCTA', 'frontOffer', 'frontLogo', 'backLogo', 'backCTA', 'backBackground', 'backBottomLeftCopy', 'backOfferBlock', 'style'];
  //displayedColumns: string[] = ['brandName', 'templateId', 'campaignTypeName', 'months', 'ageRangeName', 'gender', 'frontImage', 'frontCTA', 'frontOffer', 'frontLogo', 'backLogo', 'backCTA', 'backBackground', 'backBottomLeftCopy', 'backOfferBlock', 'style', 'custom1', 'custom2', 'custom3', 'custom4', 'custom5'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private formBuilder: FormBuilder,
    private creativeTemplateService: CreativeTemplateService,
    private ageRangeService: AgeRangeService,
    private campaignTypeService: CampaignTypeService,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService,
    private fileService: FileService,
    private spinnerService: SpinnerService
  ) { }


  // use getter setter to define the property
  get id(): any {
    return this._id;
  }

  @Input()
  set id(val: any) {
    this._id = val;
  }

  // init
  ngOnInit() {
    this.buildForm();
    // bind campaign types
    this.campaignTypeService.getAll().subscribe(campaignResult => {
      this.campaignTypeList = campaignResult;
    });

    // bind age ranges dropdown
    this.ageRangeService.getAll().subscribe(result => {
      this.ageRangeList = result;
    }); 
  }

  //// open new rule box
  openRuleBox() {
    this.showAddRule = true;
    this.showValue = true;
  }

  getRecords(query: QueryBuilder): void {
    if (query.brandId > 0) {
      this.creativeTemplateService.getQuery(query).subscribe(result => {
        this.dataSource1.data = result;
        this.dataSource1.paginator = this.paginator; 
        this.dataSource1.sort = this.sort;
      }, error => console.error(error));
    }
  }

  // submit new rule
  addRule() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.ruleForm.invalid) {
      return;
    }
      
    this.ruleErrors = "";
    this.showValue = true;
     
    // add rule
    const model = new Rule() //this.ruleForm.value as Rule;
    model.id = (new Date()).getTime(); 
    model.fieldName = this.ruleForm.value['fieldName'];
    model.operator = this.ruleForm.value['operator'];
    model.values = this.ruleForm.value['value'].toString().split(',');

    //const index: number = this.rules.indexOf(model);
    //if (index !== -1) {  
    //if (this.rules.findIndex((item) => (item.fieldName === model.fieldName && item.operator.name === model.operator.name && item.value === model.values)) < 0) {
      this.rules.push(model);
      this.ruleForm.reset();
      this.submitted = false;
      this.showAddRule = false;

      // reset value field status
      this.showValue = false;
      this.showGender = false;
      this.showMonths = false;
      this.showAgeRange = false;
      this.showCampaignType = false;
      this.selectedValues = null;
    //} 
    //else {
    //  this.ruleErrors = "This rule already exist, please try a different combination";
    //  return;
    //}
  }

  // build form
  buildForm() {
    this.submitted = false;
    this.ruleErrors = "";
    // build form model
    this.ruleForm = this.formBuilder.group({
      fieldName: ['', Validators.required],
      operator: ['', Validators.required],
      value: ['', Validators.required]  
    });

    // build edit form model
    this.editRuleForm = this.formBuilder.group({
      id: this.currentRule.id,
      fieldName: [this.currentRule.fieldName, Validators.required],
      operator: [this.currentRule.operator, Validators.required],
      value: [this.currentRule.values.toString(), Validators.required]
    });
  }
   
  // change condition
  changeCondition(evt) {      
    this.condition = evt.target.value;    
  }

  // delete rule
  removeRule(rule: Rule) {
    const index: number = this.rules.indexOf(rule);
    if (index !== -1) {
      this.rules.splice(index, 1);
    }
    this.currentRule = new Rule;
    this.showEditRule = false;
    this.editRuleForm.reset();
  }

  // edit rule form
  editRule(rule: Rule) {
    this.currentRule = rule;
    this.editRuleSubmitted = false;
    this.editRuleErrors = "";
 
    // bind form group fields

    this.editRuleForm.controls['id'].setValue(this.currentRule.id);
    this.editRuleForm.controls['fieldName'].setValue(this.currentRule.fieldName);  
    this.editRuleForm.controls['operator'].setValue(this.currentRule.operator);
    this.editRuleForm.controls['value'].setValue(this.currentRule.values.toString());

    if (this.currentRule.fieldName === "ageRange") {
      this.ageRangeSelected = this.currentRule.values;
      this.showAgeRange = true;
      this.showCampaignType = false;
      this.showValue = false;
      this.showGender = false;
    } else
      if (this.currentRule.fieldName === "campaignType") {
        this.campaignTypeSelected = this.currentRule.values;
        this.showAgeRange = false;
        this.showCampaignType = true;
        this.showValue = false;
        this.showGender = false;
      } else
        if (this.currentRule.fieldName === "gender") {
          this.genderSelected = this.currentRule.values.toString();
          this.showAgeRange = false;
          this.showCampaignType = false;
          this.showValue = false;
          this.showGender = true;
        }
        else {
          this.showAgeRange = false;
          this.showCampaignType = false;
          this.showValue = true;
          this.showGender = false;
        }
     
    this.showAddRule = false;
    this.showEditRule = true; 
  }

  // update rule on submit
  updateRule() {
    this.editRuleSubmitted = true;
    this.editRuleErrors = "";

    // stop here if form is invalid
    if (this.editRuleForm.invalid) {
      return;
    }

    // update rule
    const model = new Rule()//this.editRuleForm.value as Rule; const model = new Rule() //this.ruleForm.value as Rule;
    model.id = (new Date()).getTime();
    model.fieldName = this.editRuleForm.value['fieldName'];
    model.operator = this.editRuleForm.value['operator'];
    model.values = this.editRuleForm.value['value'].toString().split(',');
    const index: number = this.rules.indexOf(this.currentRule);

    if (index >= 0) {    
      this.rules[index] = model;       
      this.editRuleForm.reset(); 
      this.showEditRule = false;
    } 
  }
 
  // run query
  runQuery() {
    let queryBuilder = new QueryBuilder;
    queryBuilder.condition = this.condition;
    queryBuilder.rules = this.rules;
    queryBuilder.brandId = this.id;
    this.getRecords(queryBuilder); 
    this.showUpdateCard = true; 
  }

  exportData() {
    let headerList: Array<string> = [
      "campaignTypeName",
      "brandName",
      "templateId",
      "months",
      "ageRangeName",
      "gender",
      "frontImage",
      "frontCTA",
      "frontOffer",
      "frontLogo",
      "backLogo",
      "backCTA",
      "backBackground",
      "backTopLeftCopy",
      "backOfferBlock",
      "backStoreBlock",
      "backBottomLeftCopy",
      "style"
      //"custom1",
      //"custom2",
      //"custom3",
      //"custom4",
      //"custom5"
    ];

    this.fileService.downloadFile(this.dataSource1.data, headerList, "datafile");
  }
    
  toggleValueField(fieldName: string, editMode: boolean) {
    this.ageRangeSelected = null;
    this.campaignTypeSelected = null;
    this.genderSelected = "";

    if (editMode === true) {
      this.editRuleForm.controls['value'].setValue('');
    }
    else {
      this.ruleForm.controls['value'].setValue(''); 
    }

    switch (fieldName) {
      case "ageRange":
        this.showValue = false;
        this.showGender = false;
        this.showMonths = false;
        this.showAgeRange = true;
        this.showCampaignType = false;
        break;
      case "gender":
        this.showValue = false;
        this.showGender = true;
        this.showMonths = false;
        this.showAgeRange = false;
        this.showCampaignType = false;
        break;
      case "months":
        this.showValue = true;
        this.showGender = false;
        this.showAgeRange = false;
        this.showCampaignType = false;
        break; 
      case "campaignType":
        this.showValue = false;
        this.showGender = false;
        this.showMonths = false;
        this.showAgeRange = false;
        this.showCampaignType = true;
        break;
      default:
        this.showValue = true;
        this.showGender = false;
        this.showMonths = false;
        this.showAgeRange = false;
        this.showCampaignType = false;
        break; 
    }
  }
   
  setControlValue(value, editMode: boolean) {
    if (editMode === true) {
      this.editRuleForm.controls['value'].setValue(value);  
    }
    else {
      this.ruleForm.controls['value'].setValue(value);
    }
  } 

  setControlValues(fieldName: string, $event, editMode: boolean) {
    let ids = $event;

    if (fieldName === "campaignType") {
      this.selectedValues = ids.map(a => a.name);
    }
    else {
      this.selectedValues = ids.map(a => a.range);
    }

    if (editMode === true) {
      this.editRuleForm.controls['value'].setValue(this.selectedValues.toString()); 
    }
    else {
      this.ruleForm.controls['value'].setValue(this.selectedValues.toString()); 
    }
  }

  bulkUpdate(fieldName: string, newValue: string) { 
    if (fieldName !== "" && newValue !== "" && this.dataSource1.data.length > 0)
    { 
      // confirm action
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to update all records?')
          .then((confirmed) => { 

            if (confirmed) {
              this.spinnerService.show();

                let updateModel = new QueryBuilderUpdate();
                updateModel.ids = this.dataSource1.data.map(x => x.id);
                updateModel.fieldName = fieldName;
                updateModel.newValue = newValue;  

                this.creativeTemplateService.updateBulk(updateModel).subscribe(() => {
                  this.showNotification('Your changes were saved!', 'Okay!');
                  this.runQuery(); // refresh data for export event
                  this.spinnerService.hide(); 
                });
              }

        })
        .catch(() =>
          console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
        );
    }
  }

  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }
}
